<template>
    <v-form-control :field="field">
        <template scope="api">
            <v-checkbox
                :readonly="readonly"
                :value="api.getValue()"
                @input="api.setValue"
                @blur="api.setTouched"
                :data="data"
                :caption="caption"
                :label="label"
                :error="api.getTouched() ? api.getError() : undefined"
            >
                <template v-if="label" slot="label" scope="label"><slot name="label"></slot></template>
            </v-checkbox>
        </template>
    </v-form-control>
</template>

<script>
    export default {
        name: 'form-checkbox',
        props: {
            data: [String, Number, Boolean, Object],
            label: String,
            caption: String,
            error: String,
            field: {
                type: String,
                required: true,
            },
            readonly: {
                type: Boolean,
                default: false,
            },
        },
    }
</script>


// WEBPACK FOOTER //
// FormCheckbox.vue?35242d36